import { Button, FormControl, Grid, InputLabel, MenuItem, Paper, Select, TextField } from "@material-ui/core";
import {
    createStyles, makeStyles,
    Theme
} from "@material-ui/core/styles";
import Autocomplete from "@material-ui/lab/Autocomplete";
import moment from "moment";
import React, { useEffect, useRef, useState } from "react";
import { connect } from "react-redux";
import { useHistory, useParams } from "react-router-dom";
import Api from "../../../../helpers/api";
import { FetchFinalReport, getProjects, PostFinalReport, UpdateFinalReport, uploadMediaFiles } from "../../store/actions";
const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            flexGrow: 1,
        },
        table: {
            minWidth: 700,
        },
        content: {
            width: "80%",
            flexGrow: 21,
        },
        textField: {
            marginLeft: theme.spacing(1),
            marginRight: theme.spacing(1),
        },
        hoveItem: {
            cursor: "pointer",
        },

        input: {
            padding: "1px",
        },
        tableContainer: {
            marginTop: "2rem",
            position: "sticky",
            top: "200px",
        },
    })
);

interface Props {
    newReport: any;
    onBoardingActionType: any;
    getProjects: any;
    projects: any;
    uploadMediaFiles: any;
    mediaUpload: any;
    PostFinalReport: any;
    UpdateFinalReport: any;
    fetchFinalReportData: any;
    FetchFinalReport: any

}
const StopsPlace: React.FC<Props> = ({
    newReport,
    onBoardingActionType,
    getProjects,
    projects,
    uploadMediaFiles,
    mediaUpload,
    PostFinalReport,
    UpdateFinalReport,
    fetchFinalReportData,
    FetchFinalReport

}) => {
    const classes = useStyles();
    const history = useHistory();
    const timer = useRef<any>(0);
    const [isEdit, setIsEdit] = useState<any>(false);
    const { id } = useParams<{ id: string }>();
    const [supplementarty, setSupplementarty] = useState<any>();
    const [displayProject, setDisplayProject] = useState<string>("");
    const [project, setProject] = useState<any>(null);
    const [rowData, setRowData] = useState<any>("");
    const [rowDataMode, setRowDataMode] = useState<any>("");
    const [finalReport, setFinalReport] = useState<any>("");
    const [projectClose, setProjectClose] = useState<any>("");
    const [uploading, setUploading] = useState<boolean>(false);
    const [comments, setComments] = useState<any>("");
    const [vcfFile, setVcfFile] = useState<any>();
    const [bamFile, setBamFile] = useState<any>();
    const [rowDatalink, setRawDataLink] = useState<any>();
    const [ftpLink, setFtpLink] = useState<any>()
    const fileSelectedHandler = async (e: React.ChangeEvent<{ files: any }>, type: any) => {
        const formData = new FormData();
        formData.append("file", e.target.files[0]);
        setUploading(true);
        Api.post("/media", formData).then((data: any) => {
            setMediaFile({
                ...mediaFile,
                [type]: data?.path,
            })
            setUploading(false);
        }).catch(() => {
            setUploading(false);
        });
    };
    const [mediaFile, setMediaFile] = useState<any>({
        "finalAnalysisReport": "",
        "supplementaryFile": "",
        "additionalFile": "",
        "projectCloserForm": "",
        "billOrPo": "",
    }
    );
    const handleFinalReportData = async (e: any) => {
        e.preventDefault();
        const filterPath = mediaFile
        const finalReportData = {
            project: project,
            rawDataShared: rowData === "true" ? true : false,
            sharingMode: rowDataMode,
            finalReportSent: finalReport === "true" ? true : false,
            supplementaryFileSent: supplementarty === "true" ? true : false,
            closerFormSent: projectClose,
            finalAnalysisReport: filterPath?.finalAnalysisReport,
            supplementaryFile: filterPath?.supplementaryFile !== "" ? filterPath?.supplementaryFile : undefined,
            additionalFile: filterPath?.additionalFile !== "" ? filterPath?.additionalFile : undefined,
            projectCloserForm: filterPath?.projectCloserForm,
            billOrPo: filterPath?.billOrPo,
            ftpFolder: ftpLink,
            comments: comments,
            vcfFile,
            bamFile,
            rawData: rowDatalink,
        };
        if (rowDataMode === "") {
            delete finalReportData["sharingMode"];
        }
        await PostFinalReport(finalReportData);
        history.go(`/dashboard/gnrelab/final_reports`);

    };
    useEffect(() => {
        if (onBoardingActionType === "Edit Deliverable") {
            setProject(newReport?._id)
            setDisplayProject(newReport?.projectId)
            setRowData(newReport?.deliverable?.rawDataShared === true ? "true" : "false")
            setRowDataMode(newReport?.deliverable?.sharingMode)
            setFinalReport(newReport?.deliverable?.finalReportSent === true ? "true" : "false")
            setSupplementarty(newReport?.deliverable?.supplementaryFileSent === true ? "true" : "false")
            setProjectClose(newReport?.deliverable?.closerFormSent ? newReport?.deliverable?.closerFormSent?.split("T")[0] : '')
            setComments(newReport?.deliverable?.comments)
            setBamFile(newReport?.deliverable?.bamFile)
            setVcfFile(newReport?.deliverable?.vcfFile)
            setRawDataLink(newReport?.deliverable?.rawData)
            setFtpLink(newReport?.deliverable?.ftpFolder)
            setMediaFile(
                {
                    "finalAnalysisReport": (newReport?.deliverable?.finalAnalysisReport),
                    "supplementaryFile": (newReport?.deliverable?.supplementaryFile),
                    "additionalFile": (newReport?.deliverable?.additionalFile),
                    "projectCloserForm": (newReport?.deliverable?.projectCloserForm),
                    "billOrPo": (newReport?.deliverable?.billOrPo),
                }
            )
            setIsEdit(true);
        }
    }, [onBoardingActionType])
    return (
        <form onSubmit={handleFinalReportData} style={{ width: "100%" }}>
            <Paper style={{ margin: "80px auto", width: "80%", background: "#eff", marginTop: 10 }}>
                <Grid
                    container
                    direction="row"
                    justify="space-between"
                    alignItems="flex-end"
                    spacing={2}
                    style={{ margin: "1rem auto" }}
                >
                    <Grid item xs={12} sm={4} md={3}>
                        <Autocomplete
                            id="Project_id"
                            onChange={(event, newValue) => {
                                setProject(newValue?._id);
                            }}
                            defaultValue={projects?.projectId}
                            options={projects?.results || []}
                            inputValue={displayProject}
                            blurOnSelect
                            getOptionLabel={(option: any) => {
                                return (
                                    (option?.projectId) +
                                    " " +
                                    (option?.institute?.name || "") +
                                    " " +
                                    (option?.scientist?.name || "") +
                                    "," +
                                    (option?.dealer?.firmName || "")
                                );
                            }}
                            onInputChange={(event, newInputValue) => {
                                let data = newInputValue.split(" ");
                                clearTimeout(timer.current);
                                timer.current = setTimeout(() => {
                                    // getProjects(`?bioInformaticsEntered=true&search=${newInputValue}`);
                                    if (data.length > 0) {
                                        getProjects(`?bioInformaticsEntered=true&projectId=${data[0]}`);
                                    }
                                }, 1000);
                                setDisplayProject(newInputValue)
                            }}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    className="input"
                                    label="Project Id"
                                    placeholder="Search ID/Client/Dealer Name"
                                    variant="outlined"
                                    fullWidth
                                />
                            )}
                        />
                    </Grid>
                    <Grid item xs={12} sm={4} md={3}>
                        <FormControl style={{ width: "100%" }} className="input">
                            <InputLabel>Row Data Shared</InputLabel>
                            <Select
                                className="input"
                                label="Raw Data Shared"
                                fullWidth
                                variant="outlined"
                                value={rowData || "none"}
                                style={{ width: "100%", height: "40px" }}
                                onChange={(e) => setRowData(e.target.value)}
                            >
                                <MenuItem value="none"><em>Raw Data Shared</em></MenuItem>
                                <MenuItem value="true">Yes </MenuItem>
                                <MenuItem value="false">No</MenuItem>
                            </Select>
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={4} md={3}>
                        <FormControl style={{ width: "100%" }} className="input">
                            <InputLabel>Data Share Mode</InputLabel>
                            <Select
                                className="input"
                                label="Raw Data Share Mode"
                                fullWidth
                                variant="outlined"
                                value={rowDataMode || "none"}
                                style={{ width: "100%", height: "40px" }}
                                onChange={(e) => setRowDataMode(e.target.value)}
                            >
                                <MenuItem value="none"><em>Raw Data Share Mode</em></MenuItem>
                                <MenuItem value="FTP">FTP </MenuItem>
                                <MenuItem value="Pen Drive">Pen Drive</MenuItem>
                            </Select>
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={4} md={3}>
                        <FormControl style={{ width: "100%" }} className="input">
                            <InputLabel>Final Report Sent</InputLabel>
                            <Select
                                className="input"
                                label="Final Report Sent"
                                fullWidth
                                variant="outlined"
                                value={finalReport || "none"}
                                style={{ width: "100%", height: "40px" }}
                                onChange={(e) => setFinalReport(e.target.value)}
                            >
                                <MenuItem value="none"><em>Final Report Sent</em></MenuItem>
                                <MenuItem value="true">Yes </MenuItem>
                                <MenuItem value="false">No</MenuItem>
                            </Select>
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={4} md={3}>
                        <FormControl style={{ width: "100%" }} className="input">
                            <InputLabel>Supplementarty File Send</InputLabel>
                            <Select
                                className="input"
                                label="Supplementarty File Send"
                                fullWidth
                                variant="outlined"
                                value={supplementarty || "none"}
                                style={{ width: "100%", height: "40px" }}
                                onChange={(e) => setSupplementarty(e.target.value)}
                            >
                                <MenuItem value="none"><em>Supplementarty File Send</em></MenuItem>
                                <MenuItem value="true">Yes </MenuItem>
                                <MenuItem value="false">No</MenuItem>
                            </Select>
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={4} md={3}>
                        <TextField
                            label="Closer Form Sent date"
                            variant="outlined"
                            className="input"
                            type="date"
                            fullWidth
                            value={projectClose}
                            onChange={(e: any) => setProjectClose(e.target.value)}
                            inputProps={{
                                max: moment().format("YYYY-MM-DD"),
                            }}
                        />
                    </Grid>
                    <Grid item xs={12} sm={4} md={3}>
                        <TextField
                            id="filled-number"
                            className="input"
                            label="Comments"
                            fullWidth
                            value={comments}
                            placeholder="type Comments"
                            variant="outlined"
                            onChange={(e) => setComments(e.target.value)}

                        />
                    </Grid>
                    <Grid item xs={12} sm={4} md={3}>
                        <TextField
                            id="filled-number"
                            className="input"
                            label="VCF File"
                            fullWidth
                            value={vcfFile}
                            placeholder="Add Vcf File Link"
                            variant="outlined"
                            onChange={(e) => setVcfFile(e.target.value)}

                        />
                    </Grid>
                    <Grid item xs={12} sm={4} md={3}>
                        <TextField
                            id="filled-number"
                            className="input"
                            label="Bam File"
                            fullWidth
                            value={bamFile}
                            placeholder="Add Bam File Link"
                            variant="outlined"
                            onChange={(e) => setBamFile(e.target.value)}

                        />
                    </Grid>
                    <Grid item xs={12} sm={4} md={3}>
                        <TextField
                            id="filled-number"
                            className="input"
                            label="Raw Data"
                            fullWidth
                            value={rowDatalink}
                            placeholder="Add Raw Data Link"
                            variant="outlined"
                            onChange={(e) => setRawDataLink(e.target.value)}

                        />
                    </Grid>
                    <Grid item xs={12} sm={4} md={3}>
                        <TextField
                            id="filled-number"
                            className="input"
                            label="FTP Link"
                            fullWidth
                            value={ftpLink}
                            placeholder="Add Ftp Link"
                            variant="outlined"
                            onChange={(e) => setFtpLink(e.target.value)}
                        />
                    </Grid>
                    <Grid item xs={12} sm={4} md={3}>
                        <sup
                            style={{
                                fontSize: "11px",
                                marginLeft: "15px",
                                marginTop: "15px",
                                background: "#fff",
                                color: "rgba(0, 0, 0, 0.54)",
                                letterSpacing: "0.00938em",
                            }}
                        >
                            Final Analysis Report
                        </sup>
                        <input
                            className={classes.input}
                            style={{
                                width: "100%",
                                height: "46px",
                                marginTop: "-15px",
                                padding: "11.5px 14px",
                                border: "1px solid rgba(0, 0, 0, 0.23)",
                                borderRadius: "5px",
                            }}
                            type="file"
                            name="file"
                            id="file"
                            multiple
                            onChange={(e: any) => fileSelectedHandler(e, "finalAnalysisReport")}
                        />
                    </Grid>
                    <Grid item xs={12} sm={4} md={3}>
                        <sup
                            style={{
                                fontSize: "11px",
                                marginLeft: "15px",
                                marginTop: "15px",
                                background: "#fff",
                                color: "rgba(0, 0, 0, 0.54)",
                                letterSpacing: "0.00938em",
                            }}
                        >
                            Supplementary File
                        </sup>
                        <input
                            className={classes.input}
                            style={{
                                width: "100%",
                                height: "46px",
                                marginTop: "-15px",
                                padding: "11.5px 14px",
                                border: "1px solid rgba(0, 0, 0, 0.23)",
                                borderRadius: "5px",
                            }}
                            type="file"
                            name="file"
                            id="file"
                            multiple
                            onChange={(e: any) => fileSelectedHandler(e, "supplementaryFile")}
                        />
                    </Grid>
                    <Grid item xs={12} sm={4} md={3}>
                        <sup
                            style={{
                                fontSize: "11px",
                                marginLeft: "15px",
                                marginTop: "15px",
                                background: "#fff",
                                color: "rgba(0, 0, 0, 0.54)",
                                letterSpacing: "0.00938em",
                            }}
                        >
                            Additional File
                        </sup>
                        <input
                            className={classes.input}
                            style={{
                                width: "100%",
                                height: "46px",
                                marginTop: "-15px",
                                padding: "11.5px 14px",
                                border: "1px solid rgba(0, 0, 0, 0.23)",
                                borderRadius: "5px",
                            }}
                            type="file"
                            name="file"
                            id="file"
                            multiple
                            onChange={(e: any) => fileSelectedHandler(e, "additionalFile")}
                        />
                    </Grid>
                    <Grid item xs={12} sm={4} md={3}>
                        <sup
                            style={{
                                fontSize: "11px",
                                marginLeft: "15px",
                                marginTop: "15px",
                                background: "#fff",
                                color: "rgba(0, 0, 0, 0.54)",
                                letterSpacing: "0.00938em",
                            }}
                        >
                            Project Closer Form
                        </sup>
                        <input
                            className={classes.input}
                            style={{
                                width: "100%",
                                height: "46px",
                                marginTop: "-15px",
                                padding: "11.5px 14px",
                                border: "1px solid rgba(0, 0, 0, 0.23)",
                                borderRadius: "5px",
                            }}
                            type="file"
                            name="file"
                            id="file"
                            multiple
                            onChange={(e: any) => fileSelectedHandler(e, "projectCloserForm")}
                        />
                    </Grid>
                    <Grid item xs={12} sm={4} md={3}>
                        <sup
                            style={{
                                fontSize: "11px",
                                marginLeft: "15px",
                                marginTop: "15px",
                                background: "#fff",
                                color: "rgba(0, 0, 0, 0.54)",
                                letterSpacing: "0.00938em",
                            }}
                        >
                            Bill/PO
                        </sup>
                        <input
                            className={classes.input}
                            style={{
                                width: "100%",
                                height: "46px",
                                marginTop: "-15px",
                                padding: "11.5px 14px",
                                border: "1px solid rgba(0, 0, 0, 0.23)",
                                borderRadius: "5px",
                            }}
                            type="file"
                            name="file"
                            id="file"
                            multiple
                            onChange={(e: any) => fileSelectedHandler(e, "billOrPo")}
                        />
                    </Grid>
                </Grid>
                <Grid xs={12} style={{ textAlign: "center", padding: "20px" }}>
                    <Button
                        color="primary"
                        variant="contained"
                        type="submit"
                        style={{ width: 300 }}
                        disabled={uploading}

                    >
                        {isEdit ? "update" : "Save"}
                    </Button>
                </Grid>
            </Paper>
        </form>
    );
};
const mapStateToProps = (state: any) => ({
    projects: state.GenomicsLabReducer.projects,
    mediaUpload: state.GenomicsLabReducer.mediaUpload,
    fetchFinalReportData: state.GenomicsLabReducer.fetchFinalReportData,

});
export default connect(mapStateToProps, {
    getProjects,
    uploadMediaFiles,
    PostFinalReport,
    UpdateFinalReport,
    FetchFinalReport

})(StopsPlace);
